import API from './config'

export const HistoricalIndexesAPI = {

    async save(benchs, period, infos) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/historical_indexes/save', {
                benchs: JSON.stringify(benchs),
                period: period.trim(),
                infos: JSON.stringify(infos)
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getHistoricalIndexesByBenchmarksAndPeriod(benchs, period) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/historical_indexes/getHistoricalIndexesByBenchmarksAndPeriod', {
                benchs: JSON.stringify(benchs),
                period: period
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    }
}

